module.exports = __webpack_public_path__ + "img/BaliBody5.83c4fa6c.jpg";